module.exports = __webpack_public_path__ + "img/board-icon.21103c6a.svg";